import { CurrencyPipe as globalCurrency } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { distinctUntilChanged, filter, map, Observable } from 'rxjs';
import { TranslationService } from '../services/translation.service';

@Pipe({
    name: 'currency',
    standalone: false,
})
export class CurrencyPipe implements PipeTransform {
    private translationService = inject(TranslationService);

    public transform(value: string | number): Observable<string | null> {
        const currencyPipe = new globalCurrency('en-US');

        const result = this.translationService.languageChanges$.pipe(
            distinctUntilChanged(),
            filter((language) => language != null),
            map((language) => {
                if (language === 'us') {
                    return currencyPipe.transform(value, 'USD');
                }

                return currencyPipe.transform(value, 'EUR');
            })
        );

        return result;
    }
}
